module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "linebreak",
    class: _vm.size
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49024a58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LineBreak.vue
// module id = 126
// module chunks = 0